/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { triggersListEvents } from "../funcs/triggersListEvents.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListTriggerEventsResult } from "../models/components/listtriggereventsresult.js";
import {
  ListTriggerEventsRequest,
  ListTriggerEventsSecurity,
} from "../models/operations/listtriggerevents.js";
import { unwrapAsync } from "../types/fp.js";
export type TriggerEventsQueryData = ListTriggerEventsResult;

export function prefetchTriggerEvents(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListTriggerEventsRequest,
  security?: ListTriggerEventsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTriggerEventsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTriggerEventsQuery(
  client$: GramCore,
  request: ListTriggerEventsRequest,
  security?: ListTriggerEventsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<TriggerEventsQueryData>;
} {
  return {
    queryKey: queryKeyTriggerEvents({
      id: request.id,
      limit: request.limit,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function triggerEventsQueryFn(
      ctx,
    ): Promise<TriggerEventsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(triggersListEvents(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTriggerEvents(
  parameters: {
    id: string;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "triggers", "listEvents", parameters];
}
